export default "__VITE_ASSET__5e981273__"